module.exports = __webpack_public_path__ + "img/Im12.d5948b29.png";